import PropTypes from 'prop-types';
import React from 'react';
import get from 'lodash/fp/get';
import omit from 'lodash/fp/omit';
import { connect } from 'react-redux';
import { createGetComponentByContentItem } from 'selectors/createGetComponent';
import { actionRequestNextPage } from 'actions';
import { LANDING_PAGE } from 'config/types/prop';
import { SINGLE } from 'config/types/content/component';
import { options } from 'config/reactRedux';
import getLandingPage from 'selectors/getLandingPage';
import { getLoading } from 'selectors';
import Meta from 'components/meta';
import HeaderLinks from 'components/headerLinks';
import CampaignsTracker from 'components/tracking/campaignsTracker';
import withLoader from 'components/hoc/withLoader';
import { getLandingPageShortcode } from 'utils/metadata';
import getMatch from 'selectors/getMatch';
import createGetTranslation from 'selectors/i18n';

const LandingPage = (props) => {
  const LandingPageComponent = props.component;
  const {
    metadata: {
      link,
      languageHreflang,
      // headerMeta, // We need to pass it eventually through the API as we do for the Article Page
    },
  } = props.item;

  const {
    getTranslation,
  } = props;

  const pageShortcode = getLandingPageShortcode(props.magazineEditionLanguage);

  const translatedTitle = getTranslation('meta-title', 'Babbel Magazine');
  const translatedDescription = getTranslation('meta-description', 'Real-life conversations start with stories that inspire.');
  const metaDescription = { name: 'description', content: translatedDescription };
  const metaTags = [metaDescription];

  return (
    <div>
      <Meta metaTags={metaTags} title={translatedTitle} />
      <h1 className="hidden">{translatedTitle}</h1>
      <CampaignsTracker shortlinkCode={pageShortcode} />
      <HeaderLinks
        canonicalUrl={link}
        languageHreflang={languageHreflang}
      />
      <LandingPageComponent {...omit(['component'], props)} />
    </div>
  );
};

LandingPage.propTypes = {
  component: PropTypes.elementType.isRequired,
  location: PropTypes.object.isRequired,
  ...LANDING_PAGE,
};

const mapStateToProps = (state) => {
  const landingPage = getLandingPage(state);
  const loading = getLoading(state);
  const item = get('item', landingPage);
  const getComponent = createGetComponentByContentItem(item, SINGLE);
  const getTranslation = createGetTranslation(state);
  const component = getComponent(state);
  const magazineEditionLanguage = get('params.language', getMatch(state));

  return {
    ...landingPage,
    component,
    getTranslation,
    loading: loading.content || !component,
    loadingMore: loading.more,
    magazineEditionLanguage,
  };
};

const mapDispatchToProps = (dispatch) => ({
  onLoadMore: (e) => {
    e.preventDefault();
    dispatch(actionRequestNextPage());
  },
});

const withRedux = connect(
  mapStateToProps,
  mapDispatchToProps,
  undefined,
  options,
);

export default withRedux(withLoader(LandingPage));
